// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 308 ? "quiz" : chunkId) + "." + {"308":"d89a724c","435":"300f56bd"}[chunkId] + ".css";
};